export const getCookie = (name) => {
  const cookies = decodeURIComponent(document.cookie).split(';');

  name = `${name}=`;

  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];

    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }

    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }

  return '';
};

export const setCookie = (name, value, days) => {
  const date = new Date();

  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

  const expires = `expires=${date.toUTCString()}`;

  document.cookie = `${name}=${value};${expires};path=/`;
};

export const getSearchParam = (name, defaultValue) => {
  const params = window.location.search.slice(1).split('&');

  for (let i = 0; i < params.length; i++) {
    const param = params[i].split('=');

    if (param[0] === name) {
      return param[1];
    }
  }

  return defaultValue;
};

export const parseQuery = (query) => {
  query = query || window.location.search;

  if (!query) {
    return {};
  }

  query = query.replace(/^[#?]/, '');

  const k = {};
  const re = /(?:^|&)([^=]+)(?:=([^&]*))?/g;
  let m;

  do {
    m = re.exec(query);

    if (m && m[1]) {
      k[m[1]] = m[2] || '';
    }
  } while (m);

  return k;
};

export const qsParse = (query) => {
  const params = {};

  query = query || '';

  query.split('&').forEach((item) => {
    const [key, value] = item.split('=').map((part) => decodeURIComponent(part));

    params[key] = value || '';
  });

  return params;
};

export const qsStringify = (params) => {
  const parts = [];

  Object.keys(params).forEach((key) => {
    const value = params[key] || '';

    parts.push([key, value].map((part) => encodeURIComponent(part)).join('='));
  });

  return parts.join('&');
};

export const getRandomInt = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const getRandomHexString = (length) => {
  const result = [];

  for (let i = 0; i < length; i++) {
    result.push(getRandomInt(0, 15).toString(16));
  }

  return result.join('');
};

export const getUID = () => {
  return getRandomHexString(16);
};

export const getGUID = () => {
  return [
    getRandomHexString(8),
    getRandomHexString(4),
    getRandomHexString(4),
    getRandomHexString(4),
    getRandomHexString(12),
  ].join('-');
};

export const getVID = (query) => {
  if (!query || typeof query !== 'object') {
    return '';
  }

  if (query.vid) {
    return query.vid;
  }

  if (query.utm_source === 'email' && query.utm_medium === 'email_link') {
    if (query.utm_campaign === 'android') {
      return '620';
    }

    if (query.utm_campaign === 'ios') {
      return '621';
    }
  }
};

export const getGaIdFromCookies = () => {
  let result = null;

  if (!document.cookie) {
    return result;
  }

  const parts = document.cookie.split(';');
  const gaRe = /^\s*_ga=\s*(.*?)\s*$/;

  for (let i = 0; i < parts.length; i++) {
    const part = parts[i];
    const m = part.match(gaRe);

    if (m) {
      result = m[1];
      break;
    }
  }

  if (result) {
    result = result.split('.').slice(-2).join('.');
  }

  if (!/\d+\.\d+/.test(result)) {
    result = null;
  }

  return result;
};

export const getNewGaId = () => {
  const La = (a) => {
    let b = 1;
    let c;

    if (a) {
      for (b = 0, c = a.length - 1; c >= 0; c--) {
        let d = a.charCodeAt(c);

        b = (b << 6 & 268435455) + d + (d << 14);
        d = b & 266338304;
        b = d !== 0 ? b ^ d >> 21 : b;
      }
    }

    return b;
  };

  const hd = () => {
    return Math.round(2147483647 * Math.random());
  };

  const ra = () => {
    let a = window.navigator.userAgent + (document.cookie ? document.cookie : '') + (document.referrer ? document.referrer : '');
    let b = a.length;

    for (let c = window.history.length; c > 0;) {
      a += c-- ^ b++;
    }

    return [hd() ^ La(a) & 2147483647, Math.round((new Date()).getTime() / 1E3)].join('.');
  };

  return ra();
};

export const getGaCid = (callback) => {
  gtag("get", "G-ZSV21369ML", "client_id", (clientId) => {
    if (clientId && callback) {
      callback(clientId);
    }
  });
};

export const getGaCidOld = (callback) => {
  ga(() => {
    const tracker = ga.getAll()[0];

    if (tracker) {
      const clientId = tracker.get("clientId");

      if (clientId && callback) {
        callback(clientId);
      }
    }
  });
};


export const once = (fn) => {
  let result;
  let done;

  return function () {
    if (!done) {
      result = fn.apply(this, arguments);
      fn = undefined;
      done = true;
    }

    return result;
  };
};

export const setTimer = (s, resetOnFinish, timerElementId, timerCookieId) => {
  const totalSeconds = parseInt(s, 10);
  const element = document.getElementById(timerElementId);

  if (!totalSeconds || !element) return;

  const creationTimestamp = getCookie(timerCookieId);
  let timer = totalSeconds;

  let now = new Date().getTime();

  if (!creationTimestamp) {
    setCookie(timerCookieId, now);
  } else {
    const timeDifference = Math.floor((now - parseInt(creationTimestamp, 10)) / 1000);

    if ((timer - timeDifference) < 0) {
      if (!resetOnFinish) {
        timer = 0;
      } else {
        timer = totalSeconds;
        now = new Date().getTime();
        setCookie(timerCookieId, now);
      }
    } else {
      timer -= timeDifference;
    }
  }

  let minutes, seconds;

  setInterval(() => {
    minutes = Math.floor(parseInt(timer / 60, 10));
    seconds = Math.floor(parseInt(timer % 60, 10));

    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;

    element.innerHTML = minutes + ':' + seconds;

    if (--timer < 0) {
      timer = 0;
    }
  }, 1000);
};

export const getPaymentDetails = (countryCode, platform, interval, source, useAlternateGateway) => {
  if (countryCode === 'RU' && interval === 'year') {
    interval = 'unlimited';
  }
  const paymentData = {
    mac: {
      RU: {
        month: {
          url: `https://checkout.televzr.com/billing/robokassa-tz/checkout?planId=4${source && '&custom9=' + source}`,
          price: '499 р.',
          fullPrice: '899 р.'
        },
        sixmonths: {
          url: `https://checkout.televzr.com/billing/robokassa-tz/checkout?planId=5${source && '&custom9=' + source}`,
          price: '1999 р.',
          fullPrice: "2399 р."
        },
        year: {
          url: '#',
          price: '3999 p.',
          fullPrice: "4999 р."
        },
        unlimited: {
          url: `https://checkout.televzr.com/billing/robokassa-tz/checkout?planId=6${source && '&custom9=' + source}`,
          price: '3999 р.',
          fullPrice: "4999 р."
        },
      },
      EN: {
        month: {
          url: `https://checkout.bluesnap.com/buynow/checkout?sku3834816=1&storeid=548375${source && '&custom9=' + source}`,
          fullPrice: "12,99$",
          price: '9,99$',
        },
        sixmonths: {
          url: `https://checkout.bluesnap.com/buynow/checkout?sku3269243=1&storeid=548375${source && '&custom9=' + source}`,
          price: '19,99$',
          fullPrice: "25.99$"
        },
        year: {
          url: 'https://checkout.bluesnap.com/buynow/checkout?sku3727270=1&storeid=548375',
          price: '29,99$',
          fullPrice: '39.99$'
        },
        unlimited: {
          url: `https://checkout.bluesnap.com/buynow/checkout?sku3562222=1&storeid=548375${source && '&custom9=' + source}`,
          price: '39,99$',
          fullPrice: "49.99$"
        },
      },
    },
    win: {
      RU: {
        month: {
          url: `https://checkout.televzr.com/billing/robokassa-tz/checkout?planId=1${source && '&custom9=' + source}`,
          price: '499 р.',
          fullPrice: '899 р.'
        },
        sixmonths: {
          url: `https://checkout.televzr.com/billing/robokassa-tz/checkout?planId=2${source && '&custom9=' + source}`,
          price: '1999 р.',
          fullPrice: "2399 р."
        },
        year: {
          url: '#',
          price: '3999 p.',
          fullPrice: "4999 р."
        },
        unlimited: {
          url: `https://checkout.televzr.com/billing/robokassa-tz/checkout?planId=3${source && '&custom9=' + source}`,
          price: '3999 р.',
          fullPrice: "4999 р."
        },
      },
      EN: {
        month: {
          url: `https://checkout.bluesnap.com/buynow/checkout?sku3565098=1&storeid=548375${source && '&custom9=' + source}`,
          price: '4,99$',
          fullPrice: "6,99$",
        },
        sixmonths: {
          url: `https://checkout.bluesnap.com/buynow/checkout?sku3565100=1&storeid=548375${source && '&custom9=' + source}`,
          price: '19,99$',
          fullPrice: "25.99$"
        },
        year: {
          url: 'https://checkout.bluesnap.com/buynow/checkout?sku3727270=1&storeid=548375',
          price: '29,99$',
          fullPrice: "39.99$"
        },
        unlimited: {
          url: `https://checkout.bluesnap.com/buynow/checkout?sku3565096=1&storeid=548375${source && '&custom9=' + source}`,
          price: '39,99$',
          fullPrice: "49.99$"
        },
      },
    },
  };

  const paymentDataStripe = {
    mac: {
      RU: {
        month: {
          url: `https://checkout.televzr.com/billing/robokassa-tz/checkout?planId=4${source && '&custom9=' + source}`,
          price: '499 р.',
          fullPrice: '899 р.'
        },
        sixmonths: {
          url: `https://checkout.televzr.com/billing/robokassa-tz/checkout?planId=5${source && '&custom9=' + source}`,
          price: '1999 р.',
          fullPrice: "2399 р."
        },
        year: {
          url: '#',
          price: '3999 p.',
          fullPrice: "4999 р."
        },
        unlimited: {
          url: `https://checkout.televzr.com/billing/robokassa-tz/checkout?planId=6${source && '&custom9=' + source}`,
          price: '3999 р.',
          fullPrice: "4999 р."
        },
      },
      EN: {
        month: {
          url: `https://buy.stripe.com/6oE5mJfw26kZcxy8wy?source=tz`,
          fullPrice: "11,99$",
          price: '$11,99',
        },
        sixmonths: {
          url: `https://buy.stripe.com/8wMaH3cjQeRvfJK4gh?source=tz`,
          price: '24,99$',
          fullPrice: "24.99$"
        },
        year: {
          url: 'https://buy.stripe.com/eVaaH3dnUeRvgNO6oo?source=tz',
          price: '34,99$',
          fullPrice: '34.99$'
        },
      },
    },
    win: {
      RU: {
        month: {
          url: `https://checkout.televzr.com/billing/robokassa-tz/checkout?planId=1${source && '&custom9=' + source}`,
          price: '499 р.',
          fullPrice: '899 р.'
        },
        sixmonths: {
          url: `https://checkout.televzr.com/billing/robokassa-tz/checkout?planId=2${source && '&custom9=' + source}`,
          price: '1999 р.',
          fullPrice: "2399 р."
        },
        year: {
          url: '#',
          price: '3999 p.',
          fullPrice: "4999 р."
        },
        unlimited: {
          url: `https://checkout.televzr.com/billing/robokassa-tz/checkout?planId=3${source && '&custom9=' + source}`,
          price: '3999 р.',
          fullPrice: "4999 р."
        },
      },
      EN: {
        month: {
          url: `https://buy.stripe.com/aEU6qN1Fc9xbgNO6or?source=tz`,
          price: '6,99$',
          fullPrice: "6,99$",
        },
        sixmonths: {
          url: `https://buy.stripe.com/6oE02p83AgZD9lmeUY?source=tz`,
          price: '24,99$',
          fullPrice: "24.99$"
        },
        year: {
          url: 'https://buy.stripe.com/6oEbL70B810FdBCaEJ?source=tz',
          price: '34,99$',
          fullPrice: "34.99$"
        },
      },
    },
  };

  const data = useAlternateGateway === 'stripe' ? paymentDataStripe : paymentDataStripe;
  const region = countryCode === 'RU' ? 'RU' : 'EN';

  return data[platform][region][interval];
};
